<div class="mfa-container">
    <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
    <div class="wrapper">
        <div class="heading" [ngSwitch]="selectedIndex">
            <span *ngSwitchCase = "mfaSteps.Start">
              Before you start!
            </span>
            <!-- <span *ngSwitchCase = "mfaSteps.TwoStepAuthentication">
              Choose Verification Method
            </span> -->
            <span *ngSwitchCase = "mfaSteps.VerifyOTP">
              Enter OTP
            </span>
        </div>
        <div class="content">
            <mat-horizontal-stepper labelPosition="bottom" #stepper [@.disabled]="true">
                <ng-template matStepperIcon="edit">
                    <mat-icon>check</mat-icon>
                </ng-template>

                <mat-step [stepControl]="startFormGroup" optional>
                  <form [formGroup]="startFormGroup">
                    <ng-template matStepLabel>Start</ng-template>
                    <div class="mfa-start">
                        <h2 class="title">Protect your Account with <span>2- Step Authentication</span></h2>
                        <h3 class="sub_title">Why am I being asked to do this?</h3>
                        <p>
                          It has always been our priority to protect your patient’s Protected Health Information (PHI). 
                          This new level of security provides another checkpoint to make sure the person logging in is actually you.
                        </p>
                        <h3 class="sub_title">How it works?</h3>
                        <p>
                          We will send a 4-digit code to your registered email address. You will need to enter this code to complete the login process.
                        </p>
                    </div>
                  </form>
                </mat-step>
                <!-- <mat-step [stepControl]="authTypeFormGroup" optional>
                  <form [formGroup]="authTypeFormGroup">
                    <ng-template matStepLabel>2- Step Authentication</ng-template>
                    <div class="mfa-type">
                        <h2 class="title">How would you like to receive your code?</h2>
                        <p class="p1">Please Select any one of the following method to get the <b>One Time Password</b> to your registered email id
                          or Phone number.</p>
                        <mat-radio-group aria-label="Select an option" formControlName="mfaType">
                            <mat-radio-button value="Email">Email Id</mat-radio-button>
                            <mat-radio-button value="SMS" [disabled]="true">Phone Number</mat-radio-button> 
                        </mat-radio-group>
                        <p class="p2">You will be receiving a 4 - digit code to your registerd email id or Phone number</p>
                        <div class="email-error-span" *ngIf="mfaOptionErrorFlag === true">
                          <span>Email address is not valid or not available. Please contact CareMore Health Provider Relations at (888)291-1358 or send an
                                                          email to ProviderRelations@caremore.com to update email address.</span>
                        </div>
                    </div>
                  </form>
                </mat-step> -->
                <mat-step [stepControl]="verifyOtpFormGroup" optional>
                  <form [formGroup]="verifyOtpFormGroup">
                    <ng-template matStepLabel>Verify OTP</ng-template>
                    <div class="verify-otp">
                      <h2 class="title">Please, Check your email</h2>
                      <p>Enter the 4 digit code sent to your <b>{{ userEmailId }}</b></p>
                      <div class="otp-input-wrapper">
                          <input type="number" id="inp1" #inp1 formControlName="inp1" (input)="onInput($event)" (keydown)="onKeydown($event)">
                          <input type="number" id="inp2" #inp2 formControlName="inp2" (input)="onInput($event)" (keydown)="onKeydown($event)">
                          <input type="number" id="inp3" #inp3 formControlName="inp3" (input)="onInput($event)" (keydown)="onKeydown($event)">
                          <input type="number" id="inp4" #inp4 formControlName="inp4" (input)="onInput($event)" (keydown)="onKeydown($event)">
                      </div>
                      <div class="time-remaining">
                        Time Remaining: <span>{{ displayTime }}</span>
                      </div>
                      <div *ngIf="otpVerifyErrorMsg">
                        <p class="otp-invalid-error">{{ otpVerifyErrorMsg }}</p>
                      </div>
                      <div class="userNote">
                      
              
                        If you need to update your email ID, please contact our Provider Relations team at providerrelations&#64;caremore.com or call (888) 291-1358, Option 5, for further assistance.
                        
                        
                    </div>
                      <div class="resend-code" *ngIf="isResendAllowed">
                        Did not received yet? <a (click)="onResendCodeClick()">Resend Code</a>
                      </div>
                      <div class="resend-code-msg" *ngIf="!isResendAllowed">
                        OTP has been sent to your email. Please wait for the code to arrive.
                      </div>
                  </div>
                </form>
              </mat-step>
          </mat-horizontal-stepper>
        </div>
      
        <div class="action-btn-wrapper">
            <div [ngSwitch]="selectedIndex">
              <div>
                <button type="button" class="btn secondary-btn" (click)="onCancelBtnClick()">Cancel</button>
              </div>
              <!-- <div *ngSwitchCase = "mfaSteps.TwoStepAuthentication">
                <button type="button" class="btn secondary-btn" (click)="onBackBtnClick()">Back</button>
              </div>
              <div *ngSwitchCase = "mfaSteps.VerifyOTP">
                <button type="button" class="btn secondary-btn" (click)="onBackBtnClick()">Back</button>
              </div> -->
            </div>

            <div [ngSwitch]="selectedIndex">
              <div *ngSwitchCase = "mfaSteps.Start">
                <button type="button" class="btn primary-btn" (click)="onProceedBtnClick()">Proceed</button>
              </div>
              <!-- <div *ngSwitchCase = "mfaSteps.TwoStepAuthentication">
                <button type="button" class="btn primary-btn" (click)="onGetOtpBtnClick()">Get OTP</button>
              </div> -->
              <div *ngSwitchCase = "mfaSteps.VerifyOTP">
                <button type="button" class="btn primary-btn" #verifyBtn (click)="onVerifyBtnClick()" [disabled]="!verifyOtpFormGroup.valid">Verify</button>
              </div>
            </div>
            
        </div>
    </div>

    <div class="modal fade" role="dialog" id="exceptionModal">
      <div class="modal-dialog modal-xl" style="margin-top: 300px;">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row error-icon">
              <img src="../../../assets/images/icons/Error.svg" alt="Error">
            </div>
            <p class="ex-modal-message">{{ modalMessage }}</p>
          </div>
          <div class="modal-footer  d-flex justify-content-center">
            <button type="button" class="btn modal-primary-btn" (click)="onExceptionModalClose()">Close</button>
          </div>
        </div>
      </div>
  </div>
    

</div>

<div class="modal fade" id="exceptionModal" role="dialog">
	<div class="modal-dialog" style="margin-top: 300px;">
		<div class="modal-content">
			<div class="modal-header" style="border-bottom: 0px; padding: 20px;">
        <h6 class="m-0">Login Failure</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        
      </div>
    
        <div class="modal-body">
        <p>'Sorry something went wrong, please try again later.'</p>					
        
        </div>
        <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="carelon-btn " data-bs-dismiss="modal">Close</button>
        </div>
		</div>
	</div>
</div>